import { defineMessages } from 'react-intl';

export const messages: {
	errorPrimary: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorSecondary: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	errorPrimary: {
		id: 'dynamic-cards-search-page.error_primary',
		defaultMessage: "We're having trouble searching",
		description:
			'Primary error heading displayed in the search results area when a search request fails due to a server or network issue.',
	},
	errorSecondary: {
		id: 'dynamic-cards-search-page.error_secondary',
		defaultMessage: 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
		description: 'Additional message to prompt users to try again',
	},
});
